<template>
    <div class="row dynamic-list-input mb-3">

        <div v-if="!disableNewRow" class="col-12 mb-2">
            <label class="position-relative">{{config.label}}</label>
            <button type="button" class="btn btn-success mx-1" @click="addNewRow">
                <i class="fas fa-plus"></i>
            </button>
        </div>

        <div class="col-12" v-for="(data, index) in visibleRows" :key="index">
            <div class="row">
                <div class="col-11">
                    <div class="row">
                        <b-col v-for="(inputConfig, index) in config.inputFields" :key="index" :cols="inputConfig.formSize">
                            <FormInputFormat :data="inputConfig" v-model="data[inputConfig.name]"/>
                        </b-col>
                    </div>
                </div>
                <div class="col-1">
                    <button type="button" class="btn btn-danger mx-1" @click="deleteRow(index)">
                        <i class="fas fa-trash"></i>
                    </button>
                </div>
            </div>
        </div>

        <div class="col-12" v-if="inputData.length > config.rowCountPerPage">
            <div class="row">
                <div class="col-5 text-right">
                    <button type="button" class="btn btn-primary mx-1" @click="decPageNumber">
                        <i class="fas fa-arrow-left"></i>
                    </button>
                </div>
                <div class="col-2 text-center custom-paginator pt-1">
                    <span v-for="(number, index) in new Array(getPageNumber())" :class="{activePage: (index + 1) === pageNumber}">{{index + 1}} </span>
                </div>
                <div class="col-5 text-left">
                    <button type="button" class="btn btn-primary mx-1" @click="incPageNumber">
                        <i class="fas fa-arrow-right"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "DynamicListInput",
        components: {
        },
        props: {
            value: {
                type: Array,
            },
            config: {
                type: Object,
            },
            disableNewRow: {
                type: Boolean
            },
        },
        data() {
            return {
                inputData: null,
                pageNumber: 1
            }
        },
        created() {
            if(!this.value || this.value.length < 1){
                this.inputData = [{}];
            }
            else{
                this.inputData = this.value;
            }
        },
        computed: {
            visibleRows: function () {
                if(this.inputData.length <= this.config.rowCountPerPage) {
                    return this.inputData;
                }
                else{
                    let firstIndex = this.config.rowCountPerPage * (this.pageNumber - 1);

                    return this.inputData.slice(firstIndex, firstIndex + this.config.rowCountPerPage);
                }
            }
        },
        methods: {
            addNewRow(){
                this.inputData.push({});
            },
            deleteRow(index) {
                if(this.inputData.length > 1){
                    this.inputData.splice(index, 1);
                }
                else{
                    this.inputData = [{}];
                }
            },
            getPageNumber(){
                return Math.ceil(this.inputData.length / this.config.rowCountPerPage);
            },
            decPageNumber() {
                if(this.pageNumber > 1) {
                    this.pageNumber--;
                }
            },
            incPageNumber() {
                if(this.getPageNumber() > this.pageNumber){
                    this.pageNumber++;
                }
            }
        },
        watch: {
            inputData: function (val) {
                this.$emit('input', val);
            },
            value: function () {
                if(!this.value || this.value.length < 1){
                    this.inputData = [{}];
                }
                else{
                    this.inputData = this.value;
                }
            }
        }
    }
</script>

<style scoped>
    .custom-paginator span {
        margin: 2px;
    }

    .activePage {
        font-weight: 600;
    }
</style>
